import dayjs from 'dayjs';

/**
 * 将时间字符串格式化为东八区（北京时间）显示
 * @param timeString 时间字符串
 * @returns 格式化后的时间字符串
 */
export const formatTime = (timeString: any): string => {
  if (!timeString) return '';
  const date = new Date(timeString);
  // 将 UTC 时间转换为东八区时间
  const utcTime = date.getTime();
  const beijingTime = new Date(utcTime + 8 * 60 * 60 * 1000);
  return beijingTime.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
};

/**
 * 将时间字符串格式化为东八区（北京时间）的日期显示
 * @param timeString 时间字符串
 * @returns 格式化后的日期字符串，格式为 YYYY-MM-DD
 */
export const formatDate = (timeString: any): string => {
  if (!timeString) return '';

  try {
    return dayjs(timeString).format('YYYY-MM-DD');
  } catch (error) {
    return timeString;
  }
};

/**
 *
 * @param timeString 时间字符串
 * @returns 格式化后的日期时间字符串，格式为 YYYY-MM-DD HH:mm:ss
 */
export const formatDateDefault = (timeString: any) => {
  if (!timeString) return '';

  try {
    return dayjs(timeString).format('YYYY-MM-DD HH:mm:ss');
  } catch (error) {
    return timeString;
  }
};
